import { bff } from './bff/BFFConnector';
import BFFMock from './mock/BFFMock';

const api: HttpApi = {
    bff: bff,
    mock: new BFFMock(),
};

export default api;
